import { Head } from '@zoopla/layout/head';
import { OpenGraph } from '@zoopla/assets';
import * as React from 'react';

const TITLE =
    'Zoopla > Search Property to Buy, Rent, House Prices, Estate Agents';
const DESCRIPTION =
    "Search for property with the UK's leading resource. Browse houses and flats for sale and to rent, and find estate agents in your area.";
const TYPE = 'website';

const openGraphValues = [
    { property: 'og:url', content: 'https://www.zoopla.co.uk' },
    { property: 'og:title', content: TITLE },
    { property: 'og:type', content: TYPE },
    { property: 'og:image', content: OpenGraph },
    { property: 'og:description', content: DESCRIPTION }
];

const getSchema = () => {
    return JSON.stringify(
        [
            {
                alternateName: 'Zoopla Property Search',
                potentialAction: {
                    target: 'https://www.zoopla.co.uk/search/?q={search_term_string}',
                    'query-input': 'required name=search_term_string',
                    '@type': 'SearchAction'
                },
                '@context': 'http://schema.org',
                url: 'https://www.zoopla.co.uk',
                name: 'Zoopla',
                '@type': 'WebSite'
            },
            {
                logo: 'https://www.zoopla.co.uk/static/images/logo-alt.png',
                '@context': 'http://schema.org',
                contactPoint: [
                    {
                        areaServed: 'UK',
                        telephone: '+44 20 3544 1000',
                        contactType: 'Customer service',
                        '@type': 'ContactPoint'
                    }
                ],
                url: 'https://www.zoopla.co.uk',
                name: 'Zoopla Property Group',
                sameas: [
                    'https://twitter.com/zoopla',
                    'https://www.facebook.com/ZooplaUK',
                    'https://www.instagram.com/zoopla/',
                    'https://www.youtube.com/user/ZooplaUK',
                    'https://www.linkedin.com/company/zoopla/about/',
                    'https://www.pinterest.co.uk/zoopla/',
                    'https://en.wikipedia.org/wiki/ZPG_plc'
                ],
                '@type': 'Organization'
            }
        ],
        null,
        '\t'
    );
};

const extraLinkTags = [
    {
        href: 'https://z.zoocdn.com/www/_b/static/images/apple-touch-icon-precomposed-bb48e93eb2.png',
        rel: 'apple-touch-icon-precomposed'
    },
    { href: 'https://images.ctfassets.net', rel: 'dns-prefetch' },
    { href: 'https://images.ctfassets.net', rel: 'preconnect' },
    { href: 'https://securepubads.g.doubleclick.net', rel: 'preconnect' }
];

const extraMetaTags = [
    { name: 'alexaVerifyID', content: 'wewxzTLpGKQ6OiSsFdJY3s7-QvE' }
];

export const HomepageHead = () => {
    return (
        <Head
            pageTitle={TITLE}
            pageDescription={DESCRIPTION}
            canonicalPath={'/'}
            renderSocialSharingTags={true}
            openGraphValues={openGraphValues}
            extraLinkTags={extraLinkTags}
            schema={getSchema}
            extraMetaTags={extraMetaTags}
        ></Head>
    );
};
